module.exports = __webpack_public_path__ + "kangaroo.jpg?92c7ffb5d06c6e7e0f0bc4c2b9c4117b";